export default "__VITE_ASSET__COWquovh__"